/*
Custom error thrown during the apollo pipeline if no token is available
It will show up as `networkError` on the ApolloError object returned from a useQuery call
*/
export class AuthTokenError extends Error {
  readonly name = "AuthTokenError";
  constructor(operation: string) {
    super(`${operation}: No auth token available`);
  }
}
